import { ContentProps } from '@components/CreditCardContent/components/Content.interface'

import { productCodeZable } from '@constants/productCodes'

const isZableProduct = (
    productCode: ContentProps['creditCard']['productCode']
) => {
    return productCode === productCodeZable
}

export default isZableProduct
